import { CURRICULUMS, StudentServicePath, TOPICS } from "utils/constants";
import CreateTopics from "./Create";
import permissions from "app/permissions";

export const resources = {
  name: StudentServicePath + TOPICS + "/" + CURRICULUMS + "/:id/create",
  title: "Създай тема",
  custom: <CreateTopics />,
  permission: permissions.canManageCurriculumDisciplinesTopics,
};
